/* eslint-disable import/no-unresolved */
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { Autocomplete, Card, Container, Stack, TextField } from '@material-ui/core';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useSettings from 'src/hooks/useSettings';
// import { COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD, CAMPAIGN_RULE_SET_LIST_HEAD } from 'src/constants/Dashboard';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import ProjectConfigForm from './ProjectConfigForm';
// import ProjectConfigForm from './ProjectConfigForm';
// import { getCampaignRuleData } from 'src/redux/slices/campaignrules';
// import CollapsableTableCampaignRule from './CampaignRuleTable';

export default function ProjectConfigMaster() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(getCampaignRuleData());
  }, [dispatch]);

  return (
    <Page title="Project Config Set | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Project config"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Project Config', href: PATH_DASHBOARD.general.project_config }
          ]}
        />
        <ProjectConfigForm />
      </Container>
    </Page>
  );
}
